import { SingleColumnLayout } from '@chillibean/component-library/legacy';
import { Switch, Route, Redirect } from 'react-router-dom';

import FormReportTemplateList from './FormReportTemplateList';
import FormReportTemplateReport from './FormReportTemplateReport';

function FormsNavigator() {
  return (
    <Switch>
      <Route
        exact
        path="/forms"
        render={() => {
          return (
            <SingleColumnLayout leftOffset="122px">
              <FormReportTemplateList />
            </SingleColumnLayout>
          );
        }}
      />
      <Route
        exact
        path="/forms/templates/:formTemplateID/forms"
        render={() => {
          return (
            <SingleColumnLayout leftOffset="122px" rowSpacing="none">
              <FormReportTemplateReport />
            </SingleColumnLayout>
          );
        }}
      />
      <Route render={() => <Redirect to="/" />} />
    </Switch>
  );
}

export default FormsNavigator;
